<template>
    <div>
        <span class="link-text" @click="getdata">查看</span>
        <el-dialog
            title="文章列表"
            :visible.sync="showdialog"
            width="1200px"
            v-dialogDrag>

            <div class="base-warp">
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="title" label="标题" show-overflow-tooltip=""></el-table-column>
                        <el-table-column prop="type" label="类型" align="center"></el-table-column>
                        <el-table-column prop="projectid" label="关联楼盘" width="220">
                            <template slot-scope="s">
                                <div class="flex-box">
                                    <span class="text projectname" v-if="s.row.project">{{s.row.project.name}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="click" label="阅读量" align="center"></el-table-column>
                        <el-table-column prop="zanlen" label="点赞" align="center"></el-table-column>
                        <el-table-column prop="putaway" label="状态" align="center">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.putaway">上架</span>
                                <span class="text-danger" v-else>下架</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="80">
                            <template slot-scope="s">
                                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'ProjectExpertList',
    data() {
        return {
            showdialog: false,
            form: {
                name: '',
            },
            atypes: ['不限', '动态', '点评'],
            pageNo: 1,
            pagesize: 14,
            total: 0,
            tabledata: [],
            projectid: '',
        }
    },
    props: {
        id: {
            type: String,
            default: ''
        },
    },
    mounted() {
        this.projectid = this.id;
    },
    methods: {
        putaway(row) {
            var params = {
                id: row._id['$oid'],
                putaway: !row.putaway
            }
            this.$api.putAwayProjectDynamic(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTableData();
                }
            )
        },
        getdata() {
            this.showdialog = true;
            this.pageNo = 1;
            this.getTableData();
        },
        getTableData() {
            var params = {
                projectid: this.projectid,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getExpertRemarkList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>